Ext.define('SA.view.QuickReportAddAttributeInvokedOnViewPopup', {
    alias: 'widget.quick-report-add-attribute-invoked-on-view-popup',
    extend: 'SA.view.PromptWindow',

    cls: 'sa-quick-report-add-attribute-invoked-on-view-popup',
    includeHeader: false,
    includeOkBtn: true,

    getBodyItems() {
        return {
            xtype: 'component',
            cls: 'sa-quick-report-add-attribute-invoked-on-view-popup-message',

            html: [
                '<svg class="sa-quick-report-add-attribute-invoked-on-view-popup-message-svg"><use href="#sa-icon-map-info"></use></svg>',
                '<div class="sa-quick-report-add-attribute-invoked-on-view-popup-message-text">',
                    '<strong>The content of each Quick Report is fixed, so you are not able to add additional data variables to this report.</strong>',
                    '<br><br>But we have added this variable to your project so you can use it in other views.',
                '</div>'
            ]
        };
    }
});
